import {
  validateFormat,
  validateInclusion,
  validateLength,
  validatePresence,
  validateConfirmation,
} from 'ember-changeset-validations/validators'

// Exporting the base validator just for tests
export const baseTeacherValidator = {
  firstName: [validatePresence({ presence: true, ignoreBlank: true })],
  lastName: [validatePresence({ presence: true, ignoreBlank: true })],
  email: [
    validatePresence({ presence: true, ignoreBlank: true }),
    validateLength({ min: 5, max: 255 }),
    validateFormat({ type: 'email' }),
  ],
}

// For validating teachers via the fairly basic add teacher form
export const addTeacherValidator = baseTeacherValidator

// For validating a teacher when editing. Some extra fields to validate here
export const editTeacherValidator = {
  ...baseTeacherValidator,
  login: [
    validatePresence({ presence: true, ignoreBlank: true }),
    validateLength({ min: 3, max: 255 }),
    validateFormat({
      // allowlist - only unicode letters and numbers (a-z, A-Z, å, ٤, ...), and some standard symbols
      // This matches the current backend regex pattern
      regex: /^[\p{Letter}\p{Number}+@._'-]{1,}$/gu,
    }),
  ],
  password: [
    validateLength({ min: 4, allowBlank: true }),
    validateFormat({ regex: /\s/g, inverse: true, allowBlank: true }),
  ],
  passwordConfirmation: [validateConfirmation({ on: 'password' })],
}
export const editTeacherSelfValidator = {
  ...editTeacherValidator,
  // when user is editing their own password, must send current password
  passwordCurrent: [validatePresence({ presence: true, on: 'password' })],
}

// For validating teachers imported via csv
export const csvTeacherValidator = {
  firstName: [
    ...baseTeacherValidator.firstName,
    validateFormat({
      // fail on "Teacher First Name (Enter Here)" (the value from the sample CSV, to ensure they change it)
      regex: /Teacher First Name \(Enter Here\)/g,
      inverse: true,
    }),
  ],
  lastName: [
    ...baseTeacherValidator.lastName,
    validateFormat({
      // fail on "Teacher Last Name (Enter Here)" (the value from the sample CSV, to ensure they change it)
      regex: /Teacher Last Name \(Enter Here\)/g,
      inverse: true,
    }),
  ],
  email: baseTeacherValidator.email,
  trialIndicator: [
    validateInclusion({
      list: ['Y', 'N'],
      message: '{description} should be either "Y" or "N"',
    }),
  ],
}
